<script setup lang="ts">
import { Head } from "@inertiajs/vue3"

import Heading from "@/components/Heading.vue"
import TeleworkItem from "@/components/benefits/TeleworkItem.vue"
import AppLayout from "@/layouts/AppLayout.vue"
import { rootPath, teleworkPath } from "@/routes"
import { type BreadcrumbItem } from "@/types"
import type { TeleworksShow } from "@/types/serializers"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Dashboard", href: rootPath() },
  { title: "Ayuda de Teletrabajo", href: teleworkPath() },
]

const props = defineProps<TeleworksShow>()
</script>

<template>
  <Head :title="breadcrumbs[breadcrumbs.length - 1].title" />

  <AppLayout :breadcrumbs="breadcrumbs">
    <div class="layout-container">
      <Heading
        title="Ayuda de Teletrabajo"
        description="Equipamiento ergonómico para tu home office"
      />
      <div class="max-w-[60ch]">
        <p>
          Te ayudamos a crear un espacio de trabajo cómodo y adaptado a ti en
          remoto, con una ayuda económica para equipamiento: silla y/o monitor
        </p>
        <p class="my-2">
          Las solicitudes aprobadas a partir del día 10 se incluirán en la
          nómina del mes siguiente.
        </p>

        <p class="my-2">
          Ayuda para monitor: no aplicable al equipo comercial.
        </p>
      </div>

      <div class="flex gap-4">
        <TeleworkItem
          :data="props.chair"
          item-type="chair"
          :can-apply="can_apply_chair"
          :settings="settings.chair"
        />
        <TeleworkItem
          :data="props.monitor"
          item-type="monitor"
          :can-apply="can_apply_monitor"
          :settings="settings.monitor"
        />
      </div>
    </div>
  </AppLayout>
</template>
